import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const HowItWorks = () => {
    const { t } = useTranslation();
    const steps = t("how_it_works.steps", { returnObjects: true }) || [];

    return (
        <section
            id="como-funciona"
            data-testid="how-it-works-section"
            className="py-24 md:py-32 bg-beige-50"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="gold-divider" />
                        <span className="text-xs uppercase tracking-[0.24em] text-stone-500">
                            {t("how_it_works.eyebrow")}
                        </span>
                        <span className="gold-divider" />
                    </div>
                    <h2 className="font-serif text-4xl sm:text-5xl text-stone-900 tracking-tight leading-[1.05]">
                        {t("how_it_works.title_1")}{" "}
                        <em className="italic text-gold-deep font-normal">{t("how_it_works.title_em")}</em>
                        .
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
                    {steps.map((s, i) => (
                        <motion.div
                            key={`step-${i}-${s.title}`}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                            data-testid={`step-${i + 1}`}
                            className="relative flex gap-6 md:gap-8 pb-10 border-b border-stone-200/80"
                        >
                            <div className="font-serif italic text-5xl md:text-6xl text-gold leading-none shrink-0">
                                {String(i + 1).padStart(2, "0")}
                            </div>
                            <div>
                                <h3 className="font-serif text-2xl md:text-3xl text-stone-900 leading-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-stone-600 font-light leading-relaxed">
                                    {s.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
